import * as Yup from 'yup'

export const educationValidationSchema = {
  schoolName: Yup.string().required('Required'),
  startDate: Yup.mixed().when('isSaveAndExit', {
    is: undefined,
    then: Yup.mixed().required('Required'),
  }),
  endDate: Yup.mixed().when('isSaveAndExit', {
    is: undefined,
    then: Yup.mixed()
      .test('is-greater', 'Graduated date should be greater than enrollment date', function (value) {
        const { startDate } = this.parent
        if (!value || !startDate) return false
        return Number(value) >= Number(startDate)
      })
      .required('Required')
      .nullable(),
  }),
  major: Yup.string().when('isSaveAndExit', {
    is: undefined,
    then: Yup.string().required('Required'),
  }),
  degree: Yup.string().when('isSaveAndExit', {
    is: undefined,
    then: Yup.string().required('Required'),
  }),
}

export const validationSchema = Yup.object().shape({
  educations: Yup.array().of(Yup.object().shape(educationValidationSchema)),
})
